export const LINE_BINDING_STORAGE_KEY = "member-line-binding-request";

export const saveLineBindingRequest = (payload) => {
  if (!payload) return;
  localStorage.setItem(LINE_BINDING_STORAGE_KEY, JSON.stringify(payload));
};

export const getLineBindingRequest = () => {
  const raw = localStorage.getItem(LINE_BINDING_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (err) {
    localStorage.removeItem(LINE_BINDING_STORAGE_KEY);
    return null;
  }
};

export const clearLineBindingRequest = () => {
  localStorage.removeItem(LINE_BINDING_STORAGE_KEY);
};

export const extractLineBindingNonce = (payload) =>
  payload?.nonce ||
  payload?.Nonce ||
  payload?.bindingNonce ||
  payload?.BindingNonce ||
  "";

export const extractLineBindingLiffUrl = (payload) =>
  payload?.liffUrl || payload?.LiffUrl || payload?.lineIdentityUrl || payload?.lineLoginUrl || "";

export const extractLineBindingLinkUrl = (payload) =>
  payload?.linkUrl || payload?.LinkUrl || payload?.redirectUrl || payload?.RedirectUrl || "";
